import { t } from '../i18n';

const EVIDENCE = ['b1', 'b2', 'b3'];
const CORE = ['b1', 'b2', 'b3', 'b4', 'b5'];
const FUTURE = ['b1', 'b2', 'b3'];

/** Info-Seite: erklärt Vorgehen, Datengrundlage und Weiterentwicklung von WerkDelta. */
export function InfoPage() {
  return (
    <>
      <h1>{t('info.title')}</h1>
      <p className="erklaerung">{t('info.intro')}</p>

      <div className="karte">
        <h2>{t('info.principle.title')}</h2>
        <p>{t('info.principle.p1')}</p>
        <p>{t('info.principle.p2')}</p>
        <p
          style={{
            fontFamily: 'ui-monospace, "SFMono-Regular", Menlo, Consolas, monospace',
            background: '#eef3f6',
            border: '1px solid #d7e0e7',
            borderRadius: '4px',
            padding: '0.5rem 0.75rem',
          }}
        >
          {t('info.principle.formula')}
        </p>
      </div>

      <div className="karte">
        <h2>{t('info.evidence.title')}</h2>
        <p>{t('info.evidence.p1')}</p>
        <ul>
          {EVIDENCE.map((k) => (
            <li key={k}>{t(`info.evidence.${k}`)}</li>
          ))}
        </ul>
      </div>

      <div className="karte">
        <h2>{t('info.core.title')}</h2>
        <p>{t('info.core.p1')}</p>
        <ul>
          {CORE.map((k) => (
            <li key={k}>{t(`info.core.${k}`)}</li>
          ))}
        </ul>
      </div>

      <div className="karte">
        <h2>{t('info.future.title')}</h2>
        <p>{t('info.future.p1')}</p>
        <ul>
          {FUTURE.map((k) => (
            <li key={k}>{t(`info.future.${k}`)}</li>
          ))}
        </ul>
        <p className="hinweis">{t('info.future.honest')}</p>
      </div>

      <p className="hinweis">{t('info.note')}</p>
    </>
  );
}
